import env from '../config/env';
import config from "../config/application";
import { getService, postBodyService } from "./base.service";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary';

const getAll = 'findByCountryPagination';
const create = 'add';
const update = 'update';
const deleteById = 'delete';
const findBySocietyUrl = 'findBySociety';
const countByCountry = 'countByCountry';

class CollectingEntityService {
    findBySociety(society) {
        const url = `${config.data.income.entity.url}${findBySocietyUrl}/${society}`;
        return getService(url);
    }
    async getAllEntities(username, country, page, length) {
        let valid = await permission.validPermission(
            env.transaction.entity,
            username,
            env.app.systemCode, dictionary.configApp.action.list);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.entity.url}${getAll}/${page}/${length}/${country}`;
            return getService(url);
        } else {
            return valid;
        }
    }
    getcountByCountry(country) {
        const url = `${config.data.income.entity.url}${countByCountry}/${country}`;
        return getService(url);
    }
    async saveEntity(cEntity, username) {
        let valid = await permission.validPermission(
            env.transaction.entity,
            username,
            env.app.systemCode, dictionary.configApp.action.add);

        //construyendo la url dependiendo del id del objeto entidad
        let url = `${config.data.income.entity.url}${create}`;
        if (cEntity.id !== 0) {
            url = `${config.data.income.entity.url}${update}`;
        } else {
            cEntity.id = null;
        }
        //validando permisos
        if (valid.response === undefined && valid.data.allow === true) {
            return postBodyService(url, cEntity);
        } else {
            return valid;
        }
    }
    async deleteEntity(lsCEntities, username) {
        let valid = await permission.validPermission(
            env.transaction.entity,
            username,
            env.app.systemCode, dictionary.configApp.action.delete);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.entity.url}${deleteById}`;
            return postBodyService(url, lsCEntities);
        } else {
            return valid;
        }
    }
}


export default new CollectingEntityService();